// @ts-nocheck
import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { showNotification } from 'sonata-react-components';

import { ShareReportList } from '@/components/common/ShareReportList';
import { copyToClipboard } from '@/helpers/reporting.helpers';
import { reportingFetchSharedReports } from '@/store/actions/reporting.actions';
import { getSharedReports } from '@/store/selectors/reporting.selectors';
import { getCampaigns } from '@/store/selectors/reportingAdvancedFilter.selectors';
import { deleteShareReport, updateShareReportEnabled } from '../../reporting.resources';

function ReportingSharedReportList({ sharedReportId }) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const campaignIds = useSelector(getCampaigns);
  const sharedReports = useSelector(getSharedReports);

  const [{ loading, reports }, setState] = useState({
    loading: false,
    reports: null
  });

  useEffect(() => {
    if (sharedReports) {
      setState(prevState => ({
        ...prevState,
        reports: sharedReports
      }));
    }
  }, [sharedReports]);

  useEffect(() => {
    dispatch(reportingFetchSharedReports(campaignIds, 'default'));
  }, [campaignIds, dispatch]);

  const onToggleEnabled = useCallback(
    async (sharedReportId, enabled) => {
      setState(prevState => ({ ...prevState, loading: true }));
      const updatedReports = await updateShareReportEnabled(sharedReportId, enabled)
        .then(() => reports.map(r => (r._id === sharedReportId ? { ...r, enabled } : r)))
        .catch(() => reports);
      setState(prevState => ({ ...prevState, loading: false, reports: updatedReports }));
    },
    [reports]
  );

  const onDelete = useCallback(
    async sharedReportId => {
      setState(prevState => ({ ...prevState, loading: true }));
      const updatedReports = await deleteShareReport(sharedReportId)
        .then(() => reports.filter(r => r._id !== sharedReportId))
        .catch(() => reports);
      setState(prevState => ({ ...prevState, loading: false, reports: updatedReports }));
    },
    [reports]
  );

  const onCopy = useCallback(
    sharedReportId => {
      const isReportingV2 = window.location.hash.includes('reporting-v2');
      const sharedReportSearch = isReportingV2 ? 'shared-report' : 'report';

      copyToClipboard(`${taptap.config.sonataReportingAppUrl}?${sharedReportSearch}=${sharedReportId}`);
      showNotification(
        'success',
        formatMessage({
          defaultMessage: 'The link has been copied correctly',
          id: 'reporting.shareReportModal.linkToast'
        }),
        {
          closable: true,
          icon: 'fal fa-check-circle'
        }
      );
    },
    [formatMessage]
  );

  return (
    <ShareReportList
      activeItemId={sharedReportId}
      items={reports}
      loading={loading}
      onCopy={onCopy}
      onDelete={onDelete}
      onToggleEnabled={onToggleEnabled}
    />
  );
}

export default React.memo(ReportingSharedReportList);
